module.exports = __webpack_public_path__ + "talent-1.jpg?6b184528f99e2deda81e5fd18861fba8";